import { ViewerState } from './state';
import Actions from './actions';
import Getters from './getters';
import Mutations from './mutations';
var ViewerStoreModule = /** @class */ (function () {
    function ViewerStoreModule() {
        this.getters = Getters;
        this.mutations = Mutations;
        this.actions = Actions;
        this.state = new ViewerState();
    }
    return ViewerStoreModule;
}());
export { ViewerStoreModule };
